import { WHATSAPP_TRACKING_CONFIG } from '../hooks/whatsAppTrackingConstants'
import logger from './logger'

/**
 * Sanitizes tracking event properties to prevent tracking failures
 * - Removes non-serializable values (functions, undefined, null)
 * - Truncates long string values to prevent payload size issues
 * - Logs warnings for data quality issues
 */
export function sanitizeTrackingProperties(properties: Record<string, any>): Record<string, any> {
  return Object.keys(properties).reduce((acc, key) => {
    const value = properties[key]

    // Only include serializable values
    if (value !== undefined && value !== null && typeof value !== 'function') {
      // Truncate long string values
      if (typeof value === 'string' && value.length > WHATSAPP_TRACKING_CONFIG.PERFORMANCE.MAX_PROPERTY_LENGTH) {
        acc[key] = `${value.substring(0, WHATSAPP_TRACKING_CONFIG.PERFORMANCE.MAX_PROPERTY_LENGTH)}...`
        logger.warn(`Truncated long property value for WhatsApp tracking: ${key}`)
      } else {
        acc[key] = value
      }
    }

    return acc
  }, {} as Record<string, any>)
}

/**
 * Validates tracking properties against performance thresholds
 * Logs warnings if thresholds are exceeded but doesn't modify the data
 */
export function validateTrackingProperties(properties: Record<string, any>, eventName: string): void {
  const propertyCount = Object.keys(properties).length

  if (propertyCount > WHATSAPP_TRACKING_CONFIG.PERFORMANCE.MAX_PROPERTIES_COUNT) {
    logger.warn(`Too many properties (${propertyCount}) for WhatsApp tracking event:`, eventName)
  }
}
